import React, { useState, useEffect } from 'react';
import StopTable from './StopTable';
import axios from 'axios';
import { format } from 'date-fns';
import config from '../../../config';
import AlarmModal from '../AlarmModal';

const StopPage = ({ selectedDate }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${config.apiUrl}/BoilerStopSel.do`,
          { stdate: format(selectedDate, 'yyyyMMdd') },
          { headers: { 'Content-Type': 'application/json' } },
        );

        const apiData = response.data;

        // 디버깅 로그 추가
        console.log('API Response:', apiData);

        const transformedData = transformData(apiData);

        // resultData가 빈 배열일 때 모달 열기
        if (apiData.resultData && Array.isArray(apiData.resultData) && apiData.resultData.length === 0) {
          setModalIsOpen(true);
        }

        setData(transformedData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err.response ? err.response : err);
        setError(err);
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedDate]);

  // 데이터 변환 함수
  const transformData = apiData => {
    console.log('Transform Data Input:', apiData);

    const machines = {
      '1소각': { machin: '1소각', data: [] },
      '2소각': { machin: '2소각', data: [] },
    };

    // 시간 포맷팅 함수
    const formatTime = time => {
      if (time && time.length === 4) {
        return `${time.slice(0, 2)}:${time.slice(2)}`;
      }
      return time;
    };

    if (apiData && Array.isArray(apiData.resultData)) {
      apiData.resultData.forEach(entry => {
        const machineKey = entry.SOGUBN === '001' ? '1소각' : entry.SOGUBN === '002' ? '2소각' : null;

        if (machineKey) {
          machines[machineKey].data.push({
            start: `${formatTime(entry.STRTIM)} ~ ${formatTime(entry.ENDTIM)}`,
            time: entry.SPTIME,
            stopseparate: entry.STPGNM,
            stopreason: entry.REMARK,
            stopplace: entry.STPPLM,
            detailaction: entry.MEASUM,
            delayreason: entry.DELAYX,
          });
        }
      });

      return [machines['1소각'], machines['2소각']];
    } else {
      console.error('Expected resultData to be an array but got:', apiData.resultData);
      return [machines['1소각'], machines['2소각']];
    }
  };

  // 테이블 컬럼 설정
  const columns = React.useMemo(
    () => [
      { Header: '중지시간', accessor: 'start', id: 'start' },
      { Header: '시간', accessor: 'time', id: 'time' },
      { Header: '중지구분', accessor: 'stopseparate', id: 'stopseparate' },
      { Header: '중지사유', accessor: 'stopreason', id: 'stopreason' },
      { Header: '중지장소', accessor: 'stopplace', id: 'stopplace' },
      { Header: '조치내역', accessor: 'detailaction', id: 'detailaction' },
      { Header: '지연사유', accessor: 'delayreason', id: 'delayreason' },
    ],
    [],
  );

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div className='flex flex-col c2_text'>
      {data.map(machine => (
        <div key={machine.machin} className='mb-4'>
          <div className='change-w change_2h page_center bg-blue-200 font-bold text-blue-600'>{machine.machin}</div>
          <div className='flex whitespace-nowrap overflow-x-auto'>
            <div className='b2-r'>
              <StopTable columns={columns} data={machine.data} />
            </div>
          </div>
        </div>
      ))}

      <AlarmModal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)} />
    </div>
  );
};

export default StopPage;
